export class VendSizeFlavorXref {
    ID: number;
    VendSizeID: number;
    FlavorID: number;
    MaterialNumber: string;
    MaterialDescription: string;
    Inactive: boolean;
}

export default VendSizeFlavorXref;